import zappy from '@zappy-ride/library.react.components';
import { OutputFinancials } from './Financials';

export * from './Financials';

zappy.FactoryInstance.registerComponent(OutputFinancials);
